module.exports = {
    productionSourceMap: process.env.VUE_APP_ENV !== 'production',
    publicPath: '/AB/',
    assetsDir: 'frontend-assets'
}
